import {useCallback} from 'react';
import {defaultTheme} from '@stencil/build-theme';
import RightDoubleArrowIcon from '../../../../../../../stories/Icons/RightDoubleArrow';
import RoundedCheckbox from '../../../../../../../stories/Icons/RoundedCheckbox';
import Text from '../../../../../../../stories/core-components/TextFieldExpt/TextFieldExpt';
import splitRoomString from '@stencil/hotels-utils/src/split-room-string';
import {
  countrySelectorFn,
  isDatePickRequiredSelector,
  roomStringSelectorFn,
} from '@stencil/hotels-common-reducer/src/selectors';
import {useSelector, useDispatch} from 'react-redux';

import {appConfig, gaConfig} from '@stencil/hotels-config';
import RoomPerNightUI from '../../../../../../../stories/components/hotels/DetailsPageUnif/RoomPerNightUI/RoomPerNightUI';

import {
  getAdultandChildTxt,
  getComboFilteredRooms,
  isValidArray,
} from '@stencil/hotels-utils/src/common-utils';
import {
  scrollIntoViewDetails,
  scrollToEl,
} from '@stencil/hotels-utils/src/scroll-into-view-details';
import {
  detailsNavigationIdsAndValues,
  multiroomRoomOptionsContainer,
} from '@stencil/hotels-utils/src/get-details-navigation-id-and-values';

import {
  hotelLocationSelector,
  searchRoomApiRequestSelector,
  similarPropertiesSelector,
  stayTypeSelector,
  hotelNameSelector,
  isAltAccoSelector,
  entirePropertyMergedTypeSelector,
} from '@stencil/hotels-cg-reducer/src/details/selectors';

import {
  checkinSelectorFn,
  checkoutSelectorFn,
  goingForwardPropertyIdSelector,
} from '@stencil/hotels-common-reducer/src/selectors';

import dateformat from 'dateformat';
import DPSoldOut from '../../../../../../../stories/components/hotels/DetailsPage/SoldOut/DPSoldOut';
import {detailsPagePushGaThunk} from '@stencil/hotels-ga/src';

import {isDate} from '@stencil/type-guards';
import getSrpUrl from '@stencil/hotels-utils/src/get-srp-url';

//Selectors
import {
  recommendedCombosSelector,
  isEntirePropertySelector,
} from '@stencil/hotels-cg-reducer/src/details/selectors';

//Styles
import * as S from './MultiRoomQuickBook.styles';
import {getSlashAndShowPriceCg} from '@stencil/hotels-utils/src/get-details-slash-and-show-price';
import {omnitureThunk, omnitureConfig} from '@stencil/omniture-analytics/src';
import {
  detailsClick,
  DetailsPageComponents,
} from '@stencil/omniture-analytics/src/constants/details';
import {HiddenElement} from '../../../../../../../stories/components/CommonStyleUtils/dwebCommon.styles';

//components
import CheckAvailabilityAltAcco from '../../../../../../../stories/components/hotels/DetailsPageUnif/CheckAvailabilityAltAcco/CheckAvailabilityAltAcco';
import {rupeeString} from '@stencil/hotels-config/src/config/app-config';

export default function MultiRoomQuickBook({
  activeBankCode = '',
  isAltAccount = false,
  handlOpenCalendar = () => {},
}) {
  const {DetailsGAClickEventActions, QuickBookViewRoomOptionsLabel} = gaConfig;

  const comboListFromCg = useSelector(recommendedCombosSelector);

  const getComboList = () => {
    let copyComboList = JSON.parse(JSON.stringify(comboListFromCg));
    copyComboList.map(element => {
      let filteredRooms = getComboFilteredRooms(element);
      element.rooms = filteredRooms;
    });
    return copyComboList;
  };

  const comboList = getComboList();

  let roomStrings = useSelector(roomStringSelectorFn);
  const {roomCount, paxCount, childCount} = splitRoomString(roomStrings);
  const txt = getAdultandChildTxt(paxCount, childCount);

  const isEntireProperty = useSelector(isEntirePropertySelector);
  const isAltAcco = useSelector(isAltAccoSelector);

  const dispatch = useDispatch();

  // Sold out case handling

  const searchRoomApiRequestState = useSelector(searchRoomApiRequestSelector);
  const location = useSelector(hotelLocationSelector);
  const checkin = useSelector(checkinSelectorFn);
  const checkout = useSelector(checkoutSelectorFn);
  const roomString = useSelector(roomStringSelectorFn);
  const country = useSelector(countrySelectorFn);
  const similarPropertiesData = useSelector(similarPropertiesSelector);
  const stayType = useSelector(stayTypeSelector);
  const mergedPropType = useSelector(entirePropertyMergedTypeSelector);
  const hotelName = useSelector(hotelNameSelector);
  const isDatePickRequired = useSelector(isDatePickRequiredSelector);

  const cityName = location?.name;
  const cityId = location?.id;
  const isSoldOut = !searchRoomApiRequestState?.loading && !isValidArray(comboList);

  const thereAreSimilarHotels = !!similarPropertiesData?.slice(1)?.length;
  let srpUrl = '';

  const destination = {
    _id: cityId,
    n: cityName,
  };

  if (
    isSoldOut &&
    checkin &&
    isDate(checkin.date) &&
    checkout &&
    isDate(checkout.date) &&
    roomString &&
    destination?._id &&
    destination?.n
  ) {
    srpUrl = getSrpUrl({
      checkin,
      checkout,
      roomString,
      destination: destination,
      country,
    });
  }

  const soldOutUIs = (
    <DPSoldOut
      tryAlternateDatesClick={() => {
        dispatch(
          omnitureThunk(omnitureConfig.pages.DetailsUnif, omnitureConfig.events.ctaClick, {
            cta: {
              name: `${DetailsPageComponents.MultiRoomQuickBook}_${detailsClick.soldout.showAlternateDatesClick}`,
              type: omnitureConfig.ctaType.Button,
              componentName: DetailsPageComponents.MultiRoomQuickBook,
              destination: '',
            },
          }),
        );

        const calendarEl = document.getElementById('search-widget-checkin-input');

        if (calendarEl) {
          calendarEl.click();
        }
      }}
      showSimilarHotelsClick={() => {
        dispatch(
          omnitureThunk(omnitureConfig.pages.DetailsUnif, omnitureConfig.events.ctaClick, {
            cta: {
              name: `${DetailsPageComponents.MultiRoomQuickBook}_${detailsClick.soldout.showSimilarHotelsClick}`,
              type: omnitureConfig.ctaType.Button,
              componentName: DetailsPageComponents.MultiRoomQuickBook,
              destination: '',
            },
          }),
        );

        scrollToEl(detailsNavigationIdsAndValues.similarHotels.id);
      }}
      showSimilarHotelsText={thereAreSimilarHotels}
      onSeeOtherHotelsClick={() => {
        dispatch(
          omnitureThunk(omnitureConfig.pages.DetailsUnif, omnitureConfig.events.ctaClick, {
            cta: {
              name: `${DetailsPageComponents.MultiRoomQuickBook}_${detailsClick.soldout.seeOtherHotelsClick}`,
              type: omnitureConfig.ctaType.Button,
              componentName: DetailsPageComponents.MultiRoomQuickBook,
              destination: '',
            },
          }),
        );
      }}
      srpUrl={thereAreSimilarHotels ? '' : srpUrl}
      cityName={cityName}
    />
  );

  const getMinimumPriceCombo = () => {
    let mimimumComboData = comboList[0];
    const {showPrice: miniumShowPrice} = getSlashAndShowPriceCg(
      mimimumComboData?.comboTariff,
      activeBankCode,
    );
    comboList.forEach(element => {
      const {showPrice} = getSlashAndShowPriceCg(element?.comboTariff, activeBankCode);

      if (showPrice < miniumShowPrice) {
        mimimumComboData = element;
      }
    });
    return mimimumComboData;
  };

  const getQuickBookComboTpl = () => {
    const comboData = getMinimumPriceCombo();
    const {showPrice, slashedPrice, tnc, priceDisplayMsg} = getSlashAndShowPriceCg(
      comboData?.comboTariff,
      activeBankCode,
    );

    const handleOnClickViewRoomOptions = useCallback(
      e => {
        scrollIntoViewDetails(document.querySelector('#' + multiroomRoomOptionsContainer));
        dispatch(
          omnitureThunk(omnitureConfig.pages.DetailsUnif, omnitureConfig.events.ctaClick, {
            cta: {
              name: `${DetailsPageComponents.MultiRoomQuickBook}_${detailsClick.multiRoomEventActions.Other_options_clicked}`,
              type: omnitureConfig.ctaType.Button,
              componentName: DetailsPageComponents.MultiRoomQuickBook,
              destination: '',
            },
          }),
        );
      },
      [
        multiroomRoomOptionsContainer,
        dispatch,
        omnitureThunk,
        omnitureConfig,
        DetailsPageComponents,
        detailsClick,
      ],
    );

    return (
      <S.BookingWidgetStyleContainer>
        <S.MultiRoomDetailWrapperDiv>
          <S.MultiRoomDetailLeftPara>
            <S.PaxCountSpan>
              For <strong>{txt}</strong>
            </S.PaxCountSpan>
            {comboData?.rooms &&
              comboData?.rooms.length > 0 &&
              comboData?.rooms.map((item, index) => {
                return index < 2 ? (
                  <S.FirstPropertyTypeSpan title={item?.roomName}>
                    {' '}
                    {item?.roomCount} x {item?.roomName}
                  </S.FirstPropertyTypeSpan>
                ) : null;
              })}
            {comboData?.rooms && comboData?.rooms.length > 2 ? (
              <S.FirstPropertyTypeSpan paddingBottom={'0px'}>
                {'+ ' +
                  (comboData?.rooms.length -
                    2 +
                    (comboData?.rooms.length - 2 > 1 ? ' More Rooms' : ' More Room'))}
              </S.FirstPropertyTypeSpan>
            ) : null}
            <S.FirstPropertyTypeSpan></S.FirstPropertyTypeSpan>
            {comboData?.rooms?.[0]?.ratePlans?.[0].tariffPersuasion?.mealPersuasion?.[0]?.persuasionText?.trim() ==
              'Room Only' ||
            !comboData?.rooms?.[0]?.ratePlans?.[0].tariffPersuasion?.mealPersuasion?.length ? (
              <S.AminitiesProvidedPara>
                <S.RoundedCircle>-</S.RoundedCircle>
                <span>
                  {comboData?.rooms?.[0]?.ratePlans?.[0].tariffPersuasion?.mealPersuasion?.[0]
                    ?.persuasionText
                    ? comboData?.rooms?.[0]?.ratePlans?.[0].tariffPersuasion?.mealPersuasion?.[0]
                        ?.persuasionText
                    : 'Rooms Only'}
                </span>
              </S.AminitiesProvidedPara>
            ) : (
              <S.AminitiesProvidedPara>
                <RoundedCheckbox
                  height="1rem"
                  width="1rem"
                  margin="0 0.5rem 0 0"
                  fill={defaultTheme.colors.goGreen.base}
                />
                <span>
                  {
                    comboData?.rooms?.[0]?.ratePlans?.[0].tariffPersuasion?.mealPersuasion?.[0]
                      ?.persuasionText
                  }
                </span>
              </S.AminitiesProvidedPara>
            )}

            <S.FlexItemCenter>
              {comboData?.rooms?.[0]?.ratePlans?.[0].tariffPersuasion?.cancellationPersuasion?.[0]
                ?.persuasionText ? (
                <>
                  <RoundedCheckbox
                    height="1rem"
                    width="1rem"
                    margin="0 0.5rem 0 0"
                    fill={defaultTheme.colors.goGreen.base}
                  />
                  <S.AlertTextSpan>
                    {
                      comboData?.rooms?.[0]?.ratePlans?.[0].tariffPersuasion
                        ?.cancellationPersuasion?.[0]?.persuasionText
                    }
                  </S.AlertTextSpan>
                </>
              ) : (
                <>
                  <S.RoundedCircle>-</S.RoundedCircle>
                  <S.AlertTextSpan>Non Refundable</S.AlertTextSpan>
                </>
              )}
            </S.FlexItemCenter>
          </S.MultiRoomDetailLeftPara>
          <S.MultiRoomDetailRightPara>
            {slashedPrice && showPrice && showPrice !== slashedPrice ? (
              <S.StrickedPricePara>
                {' '}
                {rupeeString} {slashedPrice}
              </S.StrickedPricePara>
            ) : null}

            <S.OriginalPricePara> {showPrice}</S.OriginalPricePara>
            {!!tnc && (
              <S.TaxInclusionPara>
                + {rupeeString} {tnc} taxes & fees
              </S.TaxInclusionPara>
            )}

            <S.RoomsAvailablePara>
              <RoomPerNightUI
                roomCount={
                  isEntireProperty ? '' : comboData?.comboTariff?.occupancydetails?.roomCount
                }
                roomText={
                  !!mergedPropType
                    ? mergedPropType
                    : comboData?.rooms?.[0]?.ratePlans?.[0]?.sellableType
                }
              />
            </S.RoomsAvailablePara>
          </S.MultiRoomDetailRightPara>
        </S.MultiRoomDetailWrapperDiv>
        {!!showPrice && (
          <HiddenElement itemProp="priceRange">
            {`${hotelName} Price Starts at ${showPrice}/Night`}
          </HiddenElement>
        )}

        <S.BookNowSection>
          {isDatePickRequired && isAltAccount ? (
            <CheckAvailabilityAltAcco handlOpenCalendar={handlOpenCalendar} />
          ) : (
            <>
              <S.ViewRoomOptionsButton onClick={handleOnClickViewRoomOptions}>
                <S.BookNowSectionText>Other options</S.BookNowSectionText>
                <S.RightDoubleArrowIconContainer>
                  <RightDoubleArrowIcon
                    width="1.2rem"
                    height="0.9rem"
                    fill={defaultTheme.colors.goBrandBlue.base}
                  />
                </S.RightDoubleArrowIconContainer>
              </S.ViewRoomOptionsButton>
              <S.BookNowButton
                onClick={() => {
                  scrollIntoViewDetails(
                    document.querySelector(
                      isAltAcco
                        ? detailsNavigationIdsAndValues.stays.id
                        : detailsNavigationIdsAndValues.rooms.id,
                    ),
                  );
                  dispatch(
                    omnitureThunk(
                      omnitureConfig.pages.DetailsUnif,
                      omnitureConfig.events.ctaClick,
                      {
                        cta: {
                          name: `${DetailsPageComponents.MultiRoomQuickBook}_${detailsClick.multiRoomEventActions.View_combo_clicked}`,
                          type: omnitureConfig.ctaType.Button,
                          componentName: DetailsPageComponents.MultiRoomQuickBook,
                          destination: '',
                        },
                      },
                    ),
                  );
                }}
              >
                <Text bold customFontSize="1.4">
                  <span>View this Combo</span>
                </Text>
              </S.BookNowButton>
            </>
          )}
        </S.BookNowSection>
      </S.BookingWidgetStyleContainer>
    );
  };

  return isSoldOut ? soldOutUIs : getQuickBookComboTpl();
}
